import { Fragment, jsx } from "react/jsx-runtime";

//#region src/components/conditional-component/ConditionalComponent.tsx
const ConditionalComponent = ({ condition, children }) => {
	if (typeof condition === "function" ? condition() : condition) return /* @__PURE__ */ jsx(Fragment, { children });
	return null;
};

//#endregion
export { ConditionalComponent };